// extracted by mini-css-extract-plugin
export default {"dialog":"styles_dialog__PAWqL","EditorModal":"styles_EditorModal__IhjjR","content":"styles_content__DMI+m","saveButton":"styles_saveButton__Fq4Fm"};